import './index.scss';
import React from 'react';
import PropTypes from 'prop-types';
import Button from 'common/components/button';
import logger from 'common/logger';
import Notification from 'common/components/notifications/legacy-notification';
import createReactClass from 'create-react-class';
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';

const messages = defineMessages({
  documentsTransferred: {
    id: '',
    defaultMessage:
      'The member has been removed and their documents are being transferred.',
    description:
      'Success notification after removing a team member and transferring their documents',
  },
  documentsKept: {
    id: '',
    defaultMessage:
      'The member has been removed and they will keep their documents.',
    description:
      'Success notification after removing a team member who will keep their documents',
  },
  userKeepsDocuments: {
    id: '',
    defaultMessage: 'User keeps them',
    description:
      'Option to let a removed team member keep their documents, templates, and API apps',
  },
  removeMemberConfirmation: {
    id: '',
    defaultMessage:
      "Confirm you'd like to remove <email>{emailAddress}</email> from your team and convert them to a free account. Who should receive their documents, templates, and API apps (if any)?",
    description:
      'Confirmation prompt shown before removing a member from a team',
  },
  activeApiKeyWarning: {
    id: '',
    defaultMessage:
      '<strong>Important:</strong> Removing a developer with an active API key could interrupt integrations currently in use. We recommend ensuring the API key is no longer in use before removing this account.',
    description:
      'Warning shown before removing a developer who has an active API key',
  },
  removeUser: {
    id: '',
    defaultMessage: 'Remove User',
    description: 'Title of the modal for removing a team member',
  },
  confirm: {
    id: '',
    defaultMessage: 'Confirm',
    description: 'Button to confirm removing a team member',
  },
  cancel: {
    id: '',
    defaultMessage: 'Cancel',
    description: 'Button to cancel removing a team member',
  },
});

const RemoveEnterpriseMember = createReactClass({
  propTypes: {
    allTeamMembers: PropTypes.arrayOf(
      PropTypes.shape({
        emailAddress: PropTypes.string.isRequired,
        guid: PropTypes.string.isRequired,
        pending: PropTypes.bool.isRequired,
      }),
    ).isRequired,
    intl: PropTypes.shape({
      formatMessage: PropTypes.func.isRequired,
    }).isRequired,
    member: PropTypes.shape({
      emailAddress: PropTypes.string.isRequired,
      guid: PropTypes.string.isRequired,
      hasTeamApiKey: PropTypes.bool.isRequired,
      remove: PropTypes.func.isRequired,
      setProperties: PropTypes.func.isRequired,
      transferToAcct: PropTypes.string,
    }).isRequired,
  },

  getInitialState() {
    return {
      transferToAcct: null,
    };
  },

  handleChange(e) {
    this.setState({
      transferToAcct: e.target.value,
    });
  },

  handleSubmit() {
    this.props.member.setProperties({
      transferToAcct: this.state.transferToAcct,
    });

    if (this.props.member.transferToAcct)
      logger.track('RemoveEnterpriseMember.transferred');

    this.props.member.remove().then(() => {
      Notification.displayNotification({
        class_name: 'success',
        text: this.state.transferToAcct
          ? this.props.intl.formatMessage(messages.documentsTransferred)
          : this.props.intl.formatMessage(messages.documentsKept),
      });
    });
  },

  makeDropdown() {
    return (
      <select onChange={(e) => this.handleChange(e)}>
        <option value="">
          <FormattedMessage {...messages.userKeepsDocuments} />
        </option>
        {this.props.allTeamMembers.map((member) => {
          return this.props.member.guid === member.guid ||
            member.pending ? null : (
            <option key={member.guid} value={member.guid}>
              {member.emailAddress}
            </option>
          );
        })}
      </select>
    );
  },

  makeLabel() {
    return (
      <label>
        <FormattedMessage
          {...messages.removeMemberConfirmation}
          values={{
            emailAddress: this.props.member.emailAddress,
            email: (...chunks) => <span className="ellipsis">{chunks}</span>,
          }}
        />
      </label>
    );
  },

  makeWarning() {
    return this.props.member.hasTeamApiKey ? (
      <div className="l-new-modal--content-wrap">
        <span className="warning-msg">
          <FormattedMessage
            {...messages.activeApiKeyWarning}
            values={{
              strong: (...chunks) => <span className="strong">{chunks}</span>,
            }}
          />
        </span>
      </div>
    ) : (
      ''
    );
  },

  render() {
    return (
      <div className="l-new-modal remove-enterprise-member">
        <div className="l-new-modal--content-wrap">
          <div className="l-new-modal--title">
            <FormattedMessage {...messages.removeUser} />
          </div>
          <div className="l-new-modal--content">
            <div className="l-new-modal--content-wrap">
              {this.makeLabel()}
              {this.makeDropdown()}
            </div>
            {this.makeWarning()}
          </div>
          <div className="l-new-modal--actions">
            <Button
              buttonText={this.props.intl.formatMessage(messages.confirm)}
              buttonColor="grasshopper"
              buttonHoverColor="ashen"
              buttonClass="m-button-submit close"
              buttonHoverTextColor="white"
              onClick={this.handleSubmit}
            />
            <Button
              buttonText={this.props.intl.formatMessage(messages.cancel)}
              buttonColor="black"
              buttonClass="m-button-submit close"
            />
          </div>
        </div>
      </div>
    );
  },
});

export default injectIntl(RemoveEnterpriseMember);
